import { render, staticRenderFns } from "./ItemSummary.vue?vue&type=template&id=6af9041b&"
import script from "./ItemSummary.vue?vue&type=script&lang=js&"
export * from "./ItemSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports